import { getIdToken } from 'firebase/auth';

import { FormSchema, type FormSchemaProps } from '@gitbook/react-uikit';

import { useCurrentUser } from '../../state';

/**
 * Form schema in the context of an integration.
 */
export function IntegrationFormSchema(
    props: FormSchemaProps<any> & {
        baseUrl: string;
    }
) {
    const { baseUrl, ...rest } = props;
    const user = useCurrentUser();

    return (
        <FormSchema
            {...rest}
            onFetchResource={async (resourceUrl: string) => {
                const data = await fetch(baseUrl + resourceUrl, {
                    headers: {
                        'x-gitbook-id-token': user ? await getIdToken(user) : '',
                    },
                }).then((res) => {
                    if (res.ok) {
                        return res.json();
                    }
                    return Promise.reject(res);
                });

                return data;
            }}
            onNavigationTo={(navigationUrl: string) => {
                const popupWidth = 640;
                const popupHeight = 550;
                window.open(
                    baseUrl + navigationUrl,
                    '_blank',
                    `popup=1,top=${(window.innerHeight - popupHeight) / 2},left=${
                        (window.innerWidth - popupWidth) / 2
                    },width=${popupWidth},height=${popupHeight}`
                );
            }}
        />
    );
}
